<div class="notifications">
  <ng-template #notificationsContainer></ng-template>
</div>
